export default __webpack_public_path__ + "f2a8634be8dc1373fbaea2341e941fed.svg";